import { Injectable, inject } from '@angular/core';

import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Action, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { filter, map, switchMap, withLatestFrom } from 'rxjs/operators';

import { TenantUserActions } from './tenant-user.actions';
import { reportEffectError } from '../../features/shared/utils/report-effect-error';
import { TenantUserService } from '../../features/user/services/tenant-user.service';
import { RootState } from '../root-state.model';

@Injectable()
export class TenantUserEffects {
  private actions$ = inject(Actions);
  private readonly store = inject<Store<RootState>>(Store);
  private readonly tenantUserService = inject(TenantUserService);

  loadUsers$: Observable<Action> = createEffect(() =>
    this.actions$.pipe(
      ofType(TenantUserActions.LoadTenantUsers),
      withLatestFrom(this.store),
      filter(([action, state]) => action.force || !state.tenantUser.users.length),
      switchMap(() => {
        return this.tenantUserService.getTenantUsers().pipe(
          map((users) => TenantUserActions.LoadTenantUsersSuccess({ users })),
          reportEffectError(TenantUserActions.LoadTenantUsersFail)
        );
      })
    )
  );
}
